import { gql } from '@apollo/client'

export const DELETE_PICOS_PRIORITY = gql`
  mutation DeletePicOSPriority($input: ID!) {
    deletePicosPriority(picosId: $input) {
      deleted
    }
  }
`
